import { SESSION_DATA_NAME } from '../config/constants';
import { OrganizationModel } from '../models';

export default {
    install(Vue) {
        let setupComplete = false;
        Vue.$store.watch(
            () => Vue.$store.state.user.isAuthenticated,
            isAuthenticated => {
                if (!isAuthenticated) {
                    setupComplete = false;
                }
                if (isAuthenticated && !setupComplete) {
                    setupComplete = true;
                    Vue.$persistentStorage.get(SESSION_DATA_NAME).then(data => {
                        OrganizationModel.loadUpdatedOrganization()
                        .then(r => r.data)
                        .then(organizations => {
                            if (!organizations.length) {
                                Vue.$store.commit('user/setAccessDenied', true);
                            } else {
                                Vue.$store.commit('organization/setOrganizations', organizations);
                                if (!data.organization) {
                                    organizations.some(organization => {
                                        data.organization = organization.id;
                                        Vue.$persistentStorage.set(SESSION_DATA_NAME, data);
                                        Vue.$store.commit(
                                            'organization/setSelectedOrganizationID',
                                            organization.id
                                        );
                                        return true;
                                    });
                                } else {
                                    Vue.$store.commit('organization/setSelectedOrganizationID', data.organization);
                                }
                            }
                        })
                        .catch(() => {});
                    });
                }
            },
            {
                immediate: true,
            }
        );
    },
};
